import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QuickPost from '../QuickPost';

// "Post to Feed": share a track / album / playlist / artist with your
// followers. Listeners who find music through the post credit you.
const ShareToFeedDialog = ({ open, onClose, music }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ pr: 6 }}>
      Post to your feed
      <IconButton aria-label="Close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {open && music && <QuickPost music={music} onSuccess={onClose} />}
    </DialogContent>
  </Dialog>
);

export default ShareToFeedDialog;
